import { orchestrator } from 'satcheljs';
import { deleteSecondaryUserEmail } from '../services/deleteSecondaryUserEmail';
import { getPremiumUser } from '../actions/getPremiumUser';
import { removeSecondaryUserEmail } from '../actions/removeSecondaryUserEmail';
import setIsRemovingEmailAddress from '../mutators/setIsRemovingEmailAddress';
import { traceSecondaryUserEmailRemoveButtonClick } from '../utils/domainOptionTracer';

export default orchestrator(
    removeSecondaryUserEmail,
    async removeSecondaryUserEmailActionMessage => {
        const { email } = removeSecondaryUserEmailActionMessage;
        traceSecondaryUserEmailRemoveButtonClick();
        setIsRemovingEmailAddress(true);
        await deleteSecondaryUserEmail(email);
        await getPremiumUser();
        setIsRemovingEmailAddress(false);
    }
);
